import React, { useState, useEffect } from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { Box, Grid } from '@mui/material'
import { useHistory } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs'

function Welcome() {
    const history = useHistory();
    const [landingData, setLandingData] = useState(null);
    const [eventsData, setEventsData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/landing`).then(res => res.json()),
            fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/events`).then(res => res.json())
        ]).then(([landingRes, eventsRes]) => {
            if (landingRes && landingRes.length > 0) {
                setLandingData(landingRes[0]);
            }
            if (eventsRes && Array.isArray(eventsRes)) {
                setEventsData(eventsRes);
            }
            setLoading(false);
        }).catch(err => {
            console.error("Error fetching landing or events data", err);
            setLoading(false);
        });
    }, []);

    const displayEvents = eventsData;


    let headingTitle = "Welcome To";
    let headingSpan = "White Wings";
    
    if (landingData && landingData.heading) {
        const parts = landingData.heading.split(' ');
        if (parts.length > 2) {
            headingSpan = parts.slice(-2).join(' '); // last two words
            headingTitle = parts.slice(0, -2).join(' '); // the rest
        } else {
            headingTitle = landingData.heading;
            headingSpan = "";
        }
    }

    const defaultPart1 = "The first biggest dream of Rajkumari Education Society turned into a vibrant reality when White Wings Pre-School, Jaipur was formally inaugurated on January 22, 2023. Our preschool is dedicated to providing a nurturing and stimulating environment, where children can embark on a journey of joyful learning and discovery.";
    const defaultPart2 = "Thank you for visiting us today. We look forward to the possibility of welcoming your child to our preschool family and embarking on an incredible journey of growth, friendship, and boundless possibilities.";

    return (
        <Container maxWidth="lg" style={{ marginTop: "50px", position: "relative", zIndex: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                    <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
                    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                </div>
            ) : (
                <Grid container spacing={4}>
                    {/* Main Welcome Content */}
                    <Grid item xs={12} md={8}>
                        <Box className="modern-card" sx={{ p: { xs: 4, md: 6 }, height: '100%' }}>
                            <Typography variant="h3" sx={{ 
                                color: 'var(--text-main)', 
                                fontWeight: '800', 
                                mb: 2,
                                fontFamily: 'var(--font-heading)'
                            }}>
                                {headingTitle} {headingSpan && <span className="text-gradient-primary">{headingSpan}</span>}
                            </Typography>
                            
                            <div style={{ 
                                width: '60px', 
                                height: '4px', 
                                background: 'var(--primary)', 
                                borderRadius: '2px',
                                marginBottom: '30px'
                            }}></div>

                            <Typography variant="body1" sx={{ color: 'var(--text-muted)', mb: 3, lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                                {(landingData && landingData.part1) || defaultPart1}
                            </Typography>

                            <Typography variant="body1" sx={{ color: 'var(--text-muted)', mb: 4, lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                                {(landingData && landingData.part2) || defaultPart2}
                            </Typography>
                            
                            {landingData && landingData.part3 && (
                                <Typography variant="body1" sx={{ color: 'var(--text-muted)', mb: 4, lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                                    {landingData.part3}
                                </Typography>
                            )}

                            {landingData && landingData.part4 && (
                                <Typography variant="body1" sx={{ color: 'var(--text-muted)', mb: 4, lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                                    {landingData.part4}
                                </Typography>
                            )}

                            <button 
                                className="btn hover-scale" 
                                onClick={() => history.push("/aboutus")}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                            >
                                Explore Our Journey <BsArrowRight style={{ color: 'white', fontSize: '1.2rem' }} />
                            </button>
                        </Box>
                    </Grid>

                    {/* Events Sidebar */}
                    <Grid item xs={12} md={4}>
                        <Box className="modern-card" sx={{ p: { xs: 4, md: 5 }, height: '100%', background: 'linear-gradient(145deg, #ffffff, #f8fafc)' }}>
                            <Typography variant="h4" sx={{ 
                                fontWeight: '700', 
                                mb: 3, 
                                color: 'var(--text-main)',
                                fontFamily: 'var(--font-heading)'
                            }}>
                                Upcoming <span style={{ color: 'var(--secondary)' }}>Events</span>
                            </Typography>

                            <style>{`
                              .events-scroll::-webkit-scrollbar { display: none; }
                              .events-scroll { -ms-overflow-style: none; scrollbar-width: none; }
                            `}</style>
                            <div className="events-scroll" style={{ display: 'flex', flexDirection: 'column', gap: '16px', maxHeight: '460px', overflowY: 'auto' }}>
                                {displayEvents.map((event, idx) => (
                                    <div key={event._id || idx} className="hover-scale" style={{ 
                                        background: '#ffffff', 
                                        borderRadius: '12px',
                                        border: '1px solid rgba(0,0,0,0.07)',
                                        overflow: 'hidden',
                                        flexShrink: 0
                                    }}>
                                        {/* Image with date overlay */}
                                        <div style={{ position: 'relative' }}>
                                            {event.imageUrl ? (
                                                <img 
                                                    src={event.imageUrl} 
                                                    alt={event.title} 
                                                    style={{ width: '100%', height: '120px', objectFit: 'cover', display: 'block' }} 
                                                />
                                            ) : (
                                                <div style={{ width: '100%', height: '60px', background: 'rgba(0, 175, 239, 0.08)' }} />
                                            )}
                                            {/* Date badge overlaid top-right */}
                                            <div style={{
                                                position: 'absolute',
                                                top: '8px',
                                                right: '10px',
                                                background: 'white',
                                                borderRadius: '8px',
                                                padding: '5px 10px',
                                                textAlign: 'center',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                minWidth: '48px'
                                            }}>
                                                <div style={{ color: 'var(--primary)', fontWeight: '800', fontSize: '1.1rem', lineHeight: 1 }}>{event.date || '-'}</div>
                                                <div style={{ color: 'var(--primary)', fontWeight: '600', fontSize: '0.7rem', textTransform: 'uppercase' }}>{event.month || ''}</div>
                                                {event.year && <div style={{ color: '#666', fontWeight: '500', fontSize: '0.65rem' }}>{event.year}</div>}
                                            </div>
                                        </div>
                                        {/* Title row */}
                                        <div style={{ padding: '8px 12px' }}>
                                            <div style={{ fontWeight: '600', fontSize: '0.9rem', color: 'var(--text-main)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {event.title || event.content || 'Untitled Event'}
                                            </div>
                                            {event.location && (
                                                <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: '2px' }}>
                                                    📍 {event.location}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Box>
                    </Grid>
                </Grid>
            )}
            <Box sx={{ height: "60px" }} />
        </Container>
    )
}

export default Welcome